export const blockIconsSocialNotificationsActive = (
	<span className='material-symbols-outlined'>notifications_active</span>
);
